<template>
    <video
        ref="videoPlayer"
        class="video-js vjs-default-skin rounded-3 shadow"
        id="helpVideo"
        controls
        >
        <!-- :data-setup="jsonString" -->
        <!-- <source
            :src="options.src"
            :type="options.type"
        /> -->
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a
            web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">
            supports HTML5 video
            </a>
        </p>
    </video>
</template>

<script>
import videojs from 'video.js';

export default {
    name: "video-player",
    props: {
        options: {
            type: Object,
            default: () => {
                return {
                    "controls": true,
                    "responsive": true,
                    "restoreEl": true,
                    "skipButtons": true,
                }
            }
        }
    },

    data() {
        return {
            player: null,
            playerReady: false
        }
    },

    watch: {
        options: {
            deep: true,
            handler: function (newConfig, old) {

                if (this.playerReady) {
                    this.$nextTick(function() {
                        // this.player = videojs(this.$refs?.videoPlayer, this.options).
                        this.player.reset();
                        this.player.src(this.options?.src)
                    })
                    // this.$nextTick(function() {
                    //     if (this.player) {
                    //         this.player?.dispose()
                    //         this.player = null;
                    //     }
                    // })
                }
            }
        },
    },


    mounted() {
        // this.options = this.options;
        this.player = videojs(this.$refs?.videoPlayer, this.options, () => {
            // this.player.log('onPlayerReady', this);
            this.playerReady = true;
            this.player.src(this.options.src)
            this.player.on('ended', () => { this.$emit('video:end') })
        })

        const myModalEl = document.getElementById('helpVideoModal')

        myModalEl.addEventListener('hidden.bs.modal', event => {
            videojs(this.$refs?.videoPlayer).pause()
        })
    },

    beforeDestroy () {
        if (this.player) {
            this.player?.dispose();
        }
    }
};
</script>
